import { DOMAIN_NAME } from '@insurancemenu/imenu-components-lib/dist/utils/urls';

export const URLS = Object.freeze({
  zywaveRedirect: `redirect.${DOMAIN_NAME}`,
});
